module.exports = __webpack_public_path__ + "static/media/arrow-left.7136a007.svg";